import './App.css';
import HomePage from "./pages/HomePage";
import {isWechat} from './utilities/Utilities';
import image from "./images/background/non_wechat_alert.png"
import {UIColors} from './config/UIConfig';

function App() {
    return (isWechat()
        ? <HomePage/>
        : <div
            style={{
            height: "100vh",
            width: "100vw",
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            backgroundColor: UIColors.backgroundSecondary
        }}>
            <img
                src={image}
                alt="Background"
                style={{
                maxHeight: "100%",
                maxWidth: "90%",
                overflow: "hidden",
                alignSelf: "center",
                justifySelf: "center",
            }}/></div>);
}

export default App;
